function getOpacity(maxValue, imagesCount) {
  return imageIndex =>
    Array.from(Array(maxValue).keys()).map(value => {
      const splitPoint = (maxValue / (imagesCount - 1)) * imageIndex
      const opacity = ((imagesCount - 1) * value) / maxValue + (1 - imageIndex)

      if (value < splitPoint) {
        return Math.max(0, opacity)
      }
      return Math.min(1, opacity)
    })
}

export default { getOpacity }
